"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = require("./Text.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Component


var Text = function Text(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  if (props.inline) {
    return _react.default.createElement(_Text.StyledInlineText, props, " ", children, " ");
  } else {
    return _react.default.createElement(_Text.StyledText, props, " ", children, " ");
  }
};

exports.Text = Text;
Text.displayName = 'Text'; // Prop Types

Text.propTypes = {
  inline: _propTypes.default.bool,
  small: _propTypes.default.bool,
  size: _propTypes.default.string,
  textColor: _propTypes.default.string,
  center: _propTypes.default.bool,
  // margin
  margin: _propTypes.default.number,
  marginXs: _propTypes.default.number,
  marginSm: _propTypes.default.number,
  marginMd: _propTypes.default.number,
  marginLg: _propTypes.default.number,
  marginXl: _propTypes.default.number,
  marginTop: _propTypes.default.number,
  marginXsTop: _propTypes.default.number,
  marginSmTop: _propTypes.default.number,
  marginMdTop: _propTypes.default.number,
  marginLgTop: _propTypes.default.number,
  marginXlTop: _propTypes.default.number,
  marginRight: _propTypes.default.number,
  marginXsRight: _propTypes.default.number,
  marginSmRight: _propTypes.default.number,
  marginMdRight: _propTypes.default.number,
  marginLgRight: _propTypes.default.number,
  marginXlRight: _propTypes.default.number,
  marginBottom: _propTypes.default.number,
  marginXsBottom: _propTypes.default.number,
  marginSmBottom: _propTypes.default.number,
  marginMdBottom: _propTypes.default.number,
  marginLgBottom: _propTypes.default.number,
  marginXlBottom: _propTypes.default.number,
  marginLeft: _propTypes.default.number,
  marginXsLeft: _propTypes.default.number,
  marginSmLeft: _propTypes.default.number,
  marginMdLeft: _propTypes.default.number,
  marginLgLeft: _propTypes.default.number,
  marginXlLeft: _propTypes.default.number,
  marginX: _propTypes.default.number,
  marginXsX: _propTypes.default.number,
  marginSmX: _propTypes.default.number,
  marginMdX: _propTypes.default.number,
  marginLgX: _propTypes.default.number,
  marginXlX: _propTypes.default.number,
  marginY: _propTypes.default.number,
  marginXsY: _propTypes.default.number,
  marginSmY: _propTypes.default.number,
  marginMdY: _propTypes.default.number,
  marginLgY: _propTypes.default.number,
  marginXlY: _propTypes.default.number,
  // padding
  padding: _propTypes.default.number,
  paddingXs: _propTypes.default.number,
  paddingSm: _propTypes.default.number,
  paddingMd: _propTypes.default.number,
  paddingLg: _propTypes.default.number,
  paddingXl: _propTypes.default.number,
  paddingTop: _propTypes.default.number,
  paddingXsTop: _propTypes.default.number,
  paddingSmTop: _propTypes.default.number,
  paddingMdTop: _propTypes.default.number,
  paddingLgTop: _propTypes.default.number,
  paddingXlTop: _propTypes.default.number,
  paddingRight: _propTypes.default.number,
  paddingXsRight: _propTypes.default.number,
  paddingSmRight: _propTypes.default.number,
  paddingMdRight: _propTypes.default.number,
  paddingLgRight: _propTypes.default.number,
  paddingXlRight: _propTypes.default.number,
  paddingBottom: _propTypes.default.number,
  paddingXsBottom: _propTypes.default.number,
  paddingSmBottom: _propTypes.default.number,
  paddingMdBottom: _propTypes.default.number,
  paddingLgBottom: _propTypes.default.number,
  paddingXlBottom: _propTypes.default.number,
  paddingLeft: _propTypes.default.number,
  paddingXsLeft: _propTypes.default.number,
  paddingSmLeft: _propTypes.default.number,
  paddingMdLeft: _propTypes.default.number,
  paddingLgLeft: _propTypes.default.number,
  paddingXlLeft: _propTypes.default.number,
  paddingX: _propTypes.default.number,
  paddingXsX: _propTypes.default.number,
  paddingSmX: _propTypes.default.number,
  paddingMdX: _propTypes.default.number,
  paddingLgX: _propTypes.default.number,
  paddingXlX: _propTypes.default.number,
  paddingY: _propTypes.default.number,
  paddingXsY: _propTypes.default.number,
  paddingSmY: _propTypes.default.number,
  paddingMdY: _propTypes.default.number,
  paddingLgY: _propTypes.default.number,
  paddingXlY: _propTypes.default.number
};
Text.defaultProps = {
  inline: false,
  small: false,
  size: 'default',
  color: undefined,
  center: undefined,
  // margin
  margin: undefined,
  marginXs: undefined,
  marginSm: undefined,
  marginMd: undefined,
  marginLg: undefined,
  marginXl: undefined,
  marginTop: undefined,
  marginXsTop: undefined,
  marginSmTop: undefined,
  marginMdTop: undefined,
  marginLgTop: undefined,
  marginXlTop: undefined,
  marginRight: undefined,
  marginXsRight: undefined,
  marginSmRight: undefined,
  marginMdRight: undefined,
  marginLgRight: undefined,
  marginXlRight: undefined,
  marginBottom: undefined,
  marginXsBottom: undefined,
  marginSmBottom: undefined,
  marginMdBottom: undefined,
  marginLgBottom: undefined,
  marginXlBottom: undefined,
  marginLeft: undefined,
  marginXsLeft: undefined,
  marginSmLeft: undefined,
  marginMdLeft: undefined,
  marginLgLeft: undefined,
  marginXlLeft: undefined,
  marginX: undefined,
  marginXsX: undefined,
  marginSmX: undefined,
  marginMdX: undefined,
  marginLgX: undefined,
  marginXlX: undefined,
  marginY: undefined,
  marginXsY: undefined,
  marginSmY: undefined,
  marginMdY: undefined,
  marginLgY: undefined,
  marginXlY: undefined,
  // padding
  padding: undefined,
  paddingXs: undefined,
  paddingSm: undefined,
  paddingMd: undefined,
  paddingLg: undefined,
  paddingXl: undefined,
  paddingTop: undefined,
  paddingXsTop: undefined,
  paddingSmTop: undefined,
  paddingMdTop: undefined,
  paddingLgTop: undefined,
  paddingXlTop: undefined,
  paddingRight: undefined,
  paddingXsRight: undefined,
  paddingSmRight: undefined,
  paddingMdRight: undefined,
  paddingLgRight: undefined,
  paddingXlRight: undefined,
  paddingBottom: undefined,
  paddingXsBottom: undefined,
  paddingSmBottom: undefined,
  paddingMdBottom: undefined,
  paddingLgBottom: undefined,
  paddingXlBottom: undefined,
  paddingLeft: undefined,
  paddingXsLeft: undefined,
  paddingSmLeft: undefined,
  paddingMdLeft: undefined,
  paddingLgLeft: undefined,
  paddingXlLeft: undefined,
  paddingX: undefined,
  paddingXsX: undefined,
  paddingSmX: undefined,
  paddingMdX: undefined,
  paddingLgX: undefined,
  paddingXlX: undefined,
  paddingY: undefined,
  paddingXsY: undefined,
  paddingSmY: undefined,
  paddingMdY: undefined,
  paddingLgY: undefined,
  paddingXlY: undefined
};